import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'

export const StatsProfileSectionTitle = ({ title }: { title: string }) => {
  const { colors } = useTheme()

  return (
    <FlexBox
      className={css`
        padding: 32px 20px 24px;
        width: 100%;
      `}
      justifyContent="center"
    >
      <Text
        tag="h2"
        type="subhead"
        className={css`
          font-size: 17px;
          line-height: 22px;
          letter-spacing: -0.2px;
        `}
        align="center"
        color={colors.uiWhite}
      >
        {title}
      </Text>
    </FlexBox>
  )
}
